module.exports = __webpack_public_path__ + "static/media/SerieSB-SBI.d616c5a7.pdf";